export enum EnvironmentType {
  local,
  development,
  uat,
  production
}
